import { useAppSelector } from "store/hooks";
import { getTimetableCreateDate, selectAdmissionsDeadline } from "store/slices/user";

import { getCalendarRange } from "utils/calendarRange";

/**
 * Rozsah kalendáře ze store a příznak, zda už je student načtený.
 *
 * AIDEV-NOTE: Bez načteného studenta (`isUserLoaded: false`) vychází `dateFrom` z náhradního data
 * 2023-09-01 a `dateTo` z neplatného termínu — takové argumenty by prefetch uložil pod cache klíč,
 * který stránka nikdy nepoužije. Kdo s rozsahem volá dotaz, musí `isUserLoaded` hlídat. [TD-476]
 */
export const useCalendarRange = () => {
  const timetableCreateDate = useAppSelector(getTimetableCreateDate);
  const admissionsDeadline = useAppSelector(selectAdmissionsDeadline);

  const isUserLoaded = typeof timetableCreateDate === "string" && typeof admissionsDeadline === "string";
  const { dateFrom, dateTo } = getCalendarRange(timetableCreateDate, admissionsDeadline);

  return { dateFrom, dateTo, isUserLoaded };
};
